import React, { useState } from 'react';
import Button from '../../../components/ui/Button';

import { 
  isSignedIn, 
  fetchGoogleCalendarEvents, 
  convertGoogleEventToActivity 
} from '../../../utils/googleCalendarService';

const GoogleCalendarSyncButton = ({ onImportEvents, persons, preferences }) => {
  const [isSyncing, setIsSyncing] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSync = async () => {
    if (!isSignedIn()) {
      alert('Please connect your Google Calendar in Settings first.');
      return;
    }

    setIsSyncing(true);
    
    try {
      // Calculate time range (current month)
      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      
      const calendarId = preferences?.googleCalendarId || 'primary';
      const googleEvents = await fetchGoogleCalendarEvents(
        calendarId,
        startOfMonth?.toISOString(),
        endOfMonth?.toISOString()
      );

      // Convert Google events to app format
      // Assign to first person by default (user can reassign later)
      const defaultPerson = persons?.[0] || {
        id: 1,
        name: 'Imported',
        color: '#3B82F6',
        initials: 'IM'
      };

      const importedActivities = googleEvents?.map(event => 
        convertGoogleEventToActivity(
          event,
          defaultPerson?.id,
          defaultPerson?.name,
          defaultPerson?.color,
          defaultPerson?.initials
        )
      ) || [];

      // Pass imported events to parent
      onImportEvents(importedActivities);

      // Show success message
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } catch (error) {
      console.error('Error syncing with Google Calendar:', error);
      alert('Failed to sync with Google Calendar. Please try again.');
    } finally {
      setIsSyncing(false);
    }
  };

  if (!preferences?.googleCalendarConnected) {
    return null;
  }

  return (
    <div className="relative">
      <Button
        variant={showSuccess ? "default" : "outline"}
        iconName={showSuccess ? "check" : "refresh-cw"}
        onClick={handleSync}
        disabled={isSyncing}
        loading={isSyncing}
      >
        {showSuccess ? 'Synced!' : 'Sync Google Calendar'}
      </Button>
    </div>
  );
};

export default GoogleCalendarSyncButton;
